var collapsible_list_component_rtlignore_default = {
  "ltr": "a2hFu",
  "rtl": "_1pWNU",
  "iconContainer": "F9s0w",
  "icon": "jr0ZN",
  "isExpanded": "ZaRxz",
  "listDimensions": "Tmd08"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
